import { useEffect, useRef } from 'react';

/**
 * Custom hook for auto-hover animation on hero titles
 * @param {number} delay - Delay before starting animation (default: 100ms)
 * @param {number} letterDelay - Delay between each letter animation (default: 100ms)
 * @param {number} animationDuration - Duration of each letter animation (default: 600ms)
 * @returns {React.RefObject} ref to attach to the hero title element
 */
export const useAutoHoverAnimation = (delay = 100, letterDelay = 100, animationDuration = 600) => {
    const titleRef = useRef(null);

    useEffect(() => {
        const animateTitle = () => {
            const spans = titleRef.current?.querySelectorAll('span');
            if (spans) {
                spans.forEach((span, index) => {
                    // Skip spaces and empty spans
                    if (span.textContent.trim() === '' || span.textContent === '&nbsp;') return;
                    
                    setTimeout(() => {
                        span.classList.add('auto-hover');
                        
                        // Remove the class after animation completes
                        setTimeout(() => {
                            span.classList.remove('auto-hover');
                        }, animationDuration);
                    }, index * letterDelay);
                });
            }
        };

        // Start animation after specified delay
        const timer = setTimeout(animateTitle, delay);
        
        return () => clearTimeout(timer);
    }, [delay, letterDelay, animationDuration]);

    return titleRef;
};

export default useAutoHoverAnimation;
